import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicOverlayService, OVERLAY_DATA } from '../../services/dynamic-overlay/dynamic-overlay.service';

@Component({
  selector: 'app-confirm-menu',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslateModule],
  template: `
    <div class="custom-context-menu-wrapper" [class.p-0!]="data.title || data.message">
      @if (data.title || data.message) {
        <div class="p-3 flex flex-col gap-3 max-w-[320px]">
          @if (data.title) {
            <h3 class="text-base font-semibold m-0 text-(--skz-text-primary)">{{ data.title | translate }}</h3>
          }
          @if (data.message) {
            <p class="text-sm text-(--skz-text-muted) leading-relaxed m-0">{{ data.message | translate }}</p>
          }
          <div class="flex justify-end gap-2 mt-1">
            <button mat-button (click)="cancel()">{{ 'Global.Cancel' | translate }}</button>
            <button mat-flat-button btnType="action" [color]="data.color || 'warn'" (click)="confirmed.emit()">
              @if (data.icon) {
                <mat-icon class="text-[18px]! h-[18px]! w-[18px]!">{{ data.icon }}</mat-icon>
              }
              <span>{{ data.label | translate }}</span>
            </button>
          </div>
        </div>
      } @else {
        <div class="d-flex flex-column gap-2 p-2">
          <button mat-flat-button [color]="data.color || 'warn'" (click)="confirmed.emit()">
            @if (data.icon) {
              <mat-icon>{{ data.icon }}</mat-icon>
            }
            <span>{{ data.label | translate }}</span>
          </button>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmMenuComponent {
  data = inject(OVERLAY_DATA);
  confirmed = output<void>();
  private overlay = inject(DynamicOverlayService);

  cancel() {
    this.overlay.close();
  }
}
